<script lang="ts" setup>
import type { FormSpecialCheckboxChoice } from '~/composables/useForm'

const props = defineProps<{
  data: FormSpecialCheckboxChoice
}>()

const { t } = useI18n()
const { dt } = useDirectusTranslation()

const options = computed(() => {
  return props.data.options.map((option) => {
    return {
      value: option.form_special_checkbox_choice_item_id.value,
      label: dt(option.form_special_checkbox_choice_item_id.translations)?.title ?? '',
      description: dt(option.form_special_checkbox_choice_item_id.translations)?.description ?? '',
    }
  })
})
</script>

<template>
  <div class="mb-2rem">
    <TextWithAfterLine
      :text="dt(props.data.translations)?.divider_text ?? ''"
      class="mb-4rem"
    />
    <FormKit
      :id="props.data.key"
      type="radio"
      :options="options"
      :name="props.data.key"
      :label="dt(props.data.translations)?.label"
      validation="required"
      :validation-messages="{
        required: t('form.validation.generic_choice'),
      }"
      :classes="{
        options: 'grid grid-cols-2 gap-1.6rem flex-wrap my-1rem',
        inner: 'hidden',
        legend: 'mb-2rem',
      }"
    >
      <template #label="context">
        <div
          class="h-full flex flex-col cursor-pointer select-none bg-starline-secondary px-1.5rem py-2rem text-center text-neutral-white ring-px transition duration-300ms block-light:bg-neutral-white block-light:text-neutral-black block-light:ring-neutral-gray/40 focus-within:outline hover:ring-starline-primary"
          :class="context.value === context.option.value ? 'shadow-starline !ring-3px !ring-starline-primary relative hover:ring-starline-primary' : 'shadow-none ring-neutral-darkGray'"
        >
          <span class="mb-1rem text-1.7rem font-title">{{ context.option.label }}</span>
          <span class="mb-2rem text-balance text-neutral-gray">{{ context.option.description }}</span>
          <div
            class="grid mx-auto mt-auto size-1.6rem place-items-center border-px"
            :class="context.value === context.option.value ? 'border-starline-primary text-starline-primary' : 'border-neutral-gray text-neutral-gray'"
          >
            <div v-if="context.value === context.option.value" class="i-radix-icons-check" />
          </div>
        </div>
      </template>
    </FormKit>
  </div>
</template>

<style>

</style>
